// HOOKS
import useReturnTableComponents from "../../../hooks/other/useReturnTableComponents";
// CONSTANTS
import { GET_FORM_PROPS } from "../../../constants/forms/getFormProps.form.constant";
const DEFAULT_CLASSNAMES = {
  tr: "bg-slate-100",
  checkbox: "checked:accent-primary h-full mx-4 my-5 items-center",
};

const Row = ({
  getFormProps = GET_FORM_PROPS,
  select,
  checked,
  changeHandlers = {}, // Pass into getFormProps
  data, // Pass into getFormProps
  classNames = DEFAULT_CLASSNAMES,
  columns = [],
}) => {
  const { getTableComponents } = useReturnTableComponents();

  // Add handler to fields
  const newFields = getFormProps({
    formObject: data,
    changeHandlers: changeHandlers,
  });
  const showColumn = (column) => {
    return column.show && newFields[column.id];
  };
  return (
    <tr className={classNames?.tr || DEFAULT_CLASSNAMES.tr}>
      {select && (
        <td className="">
          <input
            data-_id={data?._id}
            type="checkbox"
            name="table-row-checkbox"
            checked={checked}
            className={classNames?.checkbox || DEFAULT_CLASSNAMES.checkbox}
            onChange={changeHandlers?.handleSelect}
          />
        </td>
      )}
      {getTableComponents({
        fields: columns
          .filter(showColumn)
          .map((column) => newFields[column.id]),
      })}
    </tr>
  );
};

export default Row;
